/* eslint-disable global-require */
const flexboxgrid = require('./src/plugins/flexboxgrid');
const utilities = require('./src/plugins/utilities');

/** The legacy responsive is not mobile first,
 * then trying to cover legacy business logic
 */
const bpWidth = ['', '[@media(max-width:414px)]:', 'sm:', 'md:', 'lg:'];
const spaceSide = ['t', 'r', 'b', 'l'];
const generateSpacingPixels = (spaceType, min = -500, max = 500) => {
  const spacingValue = {};
  for (const media of bpWidth) {
    for (const side of spaceSide) {
      for (let i = min; i <= max; i++) {
        spacingValue[`${media}${spaceType}${side}-[${i}px]`] = `${media}${spaceType}${side}-[${i}px]`;
      }
    }
  }

  return spacingValue;
};

const paddingPixels = generateSpacingPixels('p', 0);
const marginPixels = generateSpacingPixels('m');
const spacingPixelsSafeList = [...Object.values(paddingPixels), ...Object.values(marginPixels)];

/** @type {import('tailwindcss').Config} */
module.exports = {
  content: [
    './src/components/**/*.{js,jsx,ts,tsx}',
    './src/pages/**/*.{js,jsx,ts,tsx}',
    './src/templates/**/*.{js,jsx,ts,tsx}',
  ],
  safelist: [...spacingPixelsSafeList],
  theme: {
    screens: require('./tailwind.screens.js'),
    extend: {
      colors: {
        beige: {
          100: '#F3F1ED',
          200: '#E9E7E0',
          300: '#DFDCD2',
          400: '#D6D2C4',
          500: '#CAC6B9',
          600: '#BEBBAF',
          700: '#B2AFA4',
        },
        cerulean: {
          100: '#89D8E5',
          200: '#5BCCE2',
          300: '#2EC0DF',
          400: '#00B4DC',
          500: '#00A4C6',
          600: '#0093AF',
          700: '#008399',
        },
        gray: {
          100: '#CCCCCC',
          200: '#B5B5B6',
          300: '#9D9D9F',
          400: '#868689',
          500: '#777779',
          600: '#686869',
          700: '#595959',
        },
        navy: {
          100: '#106899',
          200: '#0D5A88',
          300: '#0A4C77',
          400: '#063D65',
          500: '#032F54',
          600: '#021A26',
          700: '#001219',
        },
        orange: {
          100: '#FF8A73',
          200: '#F57353',
          300: '#EA5D33',
          400: '#E04613',
          500: '#D13F12',
          600: '#C13911',
          700: '#B23210',
        },
        boardwalkBeige: '#D6D2C4',
        signalRed: '#DF1F26',
        sparkCitron: '#DDDE1F',
        thunderGray: '#8E8E89',
        twilightBlue: '#0C1F2C',
        rapidBlue: '#0BACC6',
        espressoBrown: '#4E2B18',
      },
      fontFamily: {
        brown: ['Brown', 'Helvetica', 'sans-serif'],
        utopiaStdCaption: ['utopia-std-caption', 'Brown', 'Helvetica', 'sans-serif'],
        brownNormal: ['brownNormal', 'Helvetica', 'sans-serif'],
        brownNormalBold: ['brownNormalBold', 'Helvetica', 'sans-serif'],
        utopiaStdCaptionNormalBold: ['utopia-std-caption', 'brownNormalBold', 'Helvetica', 'sans-serif'],
      },
      container: {
        center: true,
        padding: {
          DEFAULT: '1rem',
          mobile: '2rem',
          tablet: '4rem',
          desktop: '5rem',
        },
      },
      padding: {
        ...paddingPixels,
      },
      margin: {
        ...marginPixels,
      },
    },
  },
  plugins: [flexboxgrid, utilities],
};
